import React from 'react';

const RightSymbol = () => (
    <svg width="16" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 6L9 17l-5-5" stroke="black" strokeWidth="2" fill="none" />
  </svg>
);

export default RightSymbol;